module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.node.parentNode || _vm.node.parentNode._expanded),
      expression: "!node.parentNode || node.parentNode._expanded"
    }],
    staticClass: "tree-node"
  }, [_c('div', {
    staticClass: "node-main",
    style: ({
      'padding-left': 16 * (_vm.node.level - 1) + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.expandOrCollapse($event)
      }
    }
  }, [_c('span', {
    staticClass: "node-triangle tofu-icon icon-triangle-right",
    class: {
      'node-triangle-hidden': !_vm.node.childNodes.length,
        'node-triangle-expand': _vm.node._expanded
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "node-checkbox tofu-icon",
    class: {
      'icon-check': _vm.node._checked,
        'icon-minus': _vm.node._hasChildChecked && !_vm.node._checked
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "node-label"
  }, [_vm._v(_vm._s(_vm.node.label))]), _vm._v(" "), (_vm.showCounter && _vm.node.childNodes.length) ? _c('span', {
    staticClass: "node-count"
  }, [_vm._v("\n            " + _vm._s(_vm.checkedChildren) + "/" + _vm._s(_vm.node.childNodes.length) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.node.childNodes), function(node) {
    return _c('tree-node', {
      key: node.id,
      attrs: {
        "node": node,
        "TreeModel": _vm.TreeModel
      },
      on: {
        "check": _vm.emitCheck
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-07a4474d!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/i-tree/src/node.vue
// module id = 609
// module chunks = 0